import { render, staticRenderFns } from "./DeliveryInfoPreview.vue?vue&type=template&id=5c55b884&scoped=true&"
import script from "./DeliveryInfoPreview.vue?vue&type=script&lang=js&"
export * from "./DeliveryInfoPreview.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryInfoPreview.vue?vue&type=style&index=0&id=5c55b884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c55b884",
  null
  
)

export default component.exports